import { render, staticRenderFns } from "./zpContent.vue?vue&type=template&id=547054c7&scoped=true&"
import script from "./zpContent.vue?vue&type=script&lang=js&"
export * from "./zpContent.vue?vue&type=script&lang=js&"
import style0 from "./zpContent.vue?vue&type=style&index=0&id=547054c7&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "547054c7",
  null
  
)

export default component.exports